export default __webpack_public_path__ + "static/media/MUBSE_logo.3aa56a32.svg";